(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.RoveforgeOffers = factory();
})(typeof window === 'undefined' ? null : window, function () {
  function resolveKit({ product, finishes = [], quantity = 1, discounts = {}, previewUnitPrice = 4900 }) {
    const count = Math.max(1, Math.min(3, parseInt(quantity, 10) || 1));
    const percentage = count === 1 ? 0 : Math.max(0, Math.min(100, Number(discounts[count]) || 0));
    const variants = Array.from({ length: count }, (_, index) => {
      const finish = String(finishes[index] || finishes[0] || 'black').toLowerCase();
      return product?.variants?.find(variant => variant.options?.some(option => String(option).toLowerCase() === finish));
    });
    const lineItems = [];
    let compareAt = 0;
    let amount = 0;
    for (const variant of variants) {
      const price = variant?.price ?? previewUnitPrice;
      compareAt += price;
      amount += price - Math.floor(price * percentage / 100);
      if (!variant) continue;
      const line = lineItems.find(item => item.id === variant.id);
      if (line) line.quantity += 1;
      else lineItems.push({ id: variant.id, quantity: 1 });
    }
    return { quantity: count, lineItems, available: variants.every(variant => Boolean(variant?.available)), compareAt, amount, saving: compareAt - amount };
  }
  return { resolveKit };
});
